import { MethodEnum } from '@enum/method.enum';
import { isString } from '@util/data/is-exist';

export const phpTemplate = (
  link: string,
  headers: Record<string, string> = {},
  body: Record<string, string> = {},
  method: MethodEnum = MethodEnum.GET,
) => {
  const headersText = Object.entries(headers)
    .filter(([, value]) => isString(value))
    .map(([key, value]) => `  '${key}' => '${value}'`);

  return `<?php
$client = new Client();

$headers = [${headersText.length > 0 ? `\n${headersText.join(',\n')}\n` : ''}];

$body = '${JSON.stringify(body, null, '\t')}';

$request = new Request('${method}', '${link}', $headers, $body);
$res = $client->sendAsync($request)->wait();
echo $res->getBody();`;
};
